import React from 'react';
import { Box, TextField, MenuItem, Button, Typography, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

// The search-and-filter bar above a table.
//
// One component so every table is searched the same way — same placement, same clear
// button, same "showing 12 of 480" line. Thirty-odd tables each growing their own filter
// bar is thirty-odd slightly different ideas of what a filter is.
//
// THE COUNT MATTERS MORE THAN IT LOOKS. A filtered table and a nearly-empty database look
// identical, and someone who does not realise a filter is on will conclude the data is
// gone. Saying "12 of 480" removes the ambiguity, and is why the bar renders the count even
// when nothing is filtered.
const TableToolbar = ({
  search,
  onSearchChange,
  searchPlaceholder = 'Search',
  searchLabel = 'Search',
  filters = [],
  onReset,
  resultCount = null,
  totalCount = null,
  children
}) => {
  const isFiltering = Boolean(search) || filters.some((f) => f.value !== '' && f.value != null);

  return (
    <Box mb={2}>
      <Box display="flex" gap={2} flexWrap="wrap" alignItems="flex-start">
        {onSearchChange && (
          <TextField
            size="small"
            label={searchLabel}
            placeholder={searchPlaceholder}
            value={search ?? ''}
            onChange={(e) => onSearchChange(e.target.value)}
            sx={{ minWidth: 240, flex: 1 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" color="disabled" />
                </InputAdornment>
              )
            }}
          />
        )}

        {filters.map((filter) => (
          <TextField
            key={filter.key}
            size="small"
            select
            label={filter.label}
            value={filter.value ?? ''}
            onChange={(e) => filter.onChange(e.target.value)}
            sx={{ minWidth: filter.minWidth || 180 }}
          >
            <MenuItem value="">{filter.allLabel || `All ${filter.label.toLowerCase()}`}</MenuItem>
            {filter.options.map((option) => (
              <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
            ))}
          </TextField>
        ))}

        {children}

        {isFiltering && onReset && (
          <Button onClick={onReset} sx={{ mt: 0.5 }}>Clear</Button>
        )}
      </Box>

      {resultCount !== null && totalCount !== null && (
        <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
          {isFiltering
            ? `Showing ${resultCount} of ${totalCount}`
            : `${totalCount} record${totalCount === 1 ? '' : 's'}`}
        </Typography>
      )}
    </Box>
  );
};

export default TableToolbar;
